import "./App.css";
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

//PAGES
import Home from "./pages/home";
import BusinessAdvisory from "./pages/business-advisory";
import InvestmentAcquisition from "./pages/investment-acquisition";
import Payroll from "./pages/payroll";
import HrSolutions from "./pages/hr-solutions";
import Contact from "./pages/contact";

//COMPONENTS
import ScrollToTop from "./scrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar/>
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/business-advisory" component={BusinessAdvisory} />
        <Route exact path="/investment-acquisition" component={InvestmentAcquisition} />
        <Route exact path="/payroll" component={Payroll} />
        <Route exact path="/hr-solutions" component={HrSolutions} />
        <Route exact path="/contact" component={Contact} />
      </Switch>
      <Footer/>
    </Router>
  );
};

export default App;
